<template>
  <div class="marketing-activity-form">
    <div class="main-title">
      <p>
        <span class="bold-text" @click="back">活动弹窗管理</span>
        <span>&gt;</span>
        <span style="font-weight: 400">{{ subtitle }}</span>
      </p>
    </div>
    <div class="main-body">
      <div class="form-container">
        <el-form ref="form" :model="formData" :rules="rules" label-width="100px" label-position="left"
                 hide-required-asterisk validate-on-rule-change>
          <el-form-item label="活动名称：" prop="name">
            <el-input v-model="formData.name" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          <el-form-item label="内容类型：" prop="type">
            <el-select v-model="formData.type" placeholder="请选择内容类型">
              <el-option label="文本" value="1"></el-option>
              <el-option label="图片" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文本内容：" v-if="formData.type === '1'" prop="content">
            <el-input type="textarea" v-model="formData.content" show-word-limit maxlength="1000"
                      :autosize="{ minRows: 4, maxRows: 10}" placeholder="请输入文本内容"></el-input>
          </el-form-item>
          <el-form-item label="图片预览：" v-if="formData.type === '2'" prop="imageSrc">
            <el-upload
              action=""
              :show-file-list="false"
              :auto-upload="false"
              accept="image/*"
              :on-change="handleUpload">
              <el-button size="small" type="primary">{{ imageSrc ? '重新选择' : '上传图片' }}</el-button>
              <!--              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>-->
            </el-upload>
            <div v-if="imageSrc"
                 style="padding: 20px 0; display: flex; align-items: center; justify-content: space-between">
              <el-image :src="imageSrc" style="width: 100px" fit="fill" alt=""/>
              <i class="el-icon-circle-close" style="font-size: 20px" @click="imageSrc = ''"></i>
            </div>
          </el-form-item>
          <el-form-item label="所属组织：" prop="unitNo">
            <el-cascader
              class="fixed-width-200"
              :options="unitList"
              :props="{ checkStrictly: true, value: 'unitNo', label: 'name', children: 'subUnit' }"
              v-model="unitNos"
              placeholder="请选择所属组织"
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="启用情况：" prop="enableStatus">
            <el-select v-model="formData.enableStatus" placeholder="请选择启用情况">
              <el-option label="启用" value="1"></el-option>
              <el-option label="停用" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button type="primary" @click="back">取消</el-button>
          <el-button type="primary" @click="onSubmit">确认{{ type === 1 ? '新增' : '修改' }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "marketingActivityForm",
  props: {
    type: {
      type: Number,
      default: 1
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    unitList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    const data = this.data;
    let formData;
    let unitNos;
    let imageSrc;
    if (data.number) {
      formData = {
        number: data.number,
        name: data.name,
        type: data.type,
        unitNo: data.unitNo,
        content: data.content,
        imageSrc: data.imageSrc,
        enableStatus: data.enableStatus,
      };
      unitNos = data.unitNoList;
      imageSrc = data.imageSrc;
    } else {
      formData = {
        number: '',
        name: '',
        type: '',
        unitNo: '',
        content: '',
        imageSrc: '',
        enableStatus: ''
      };
      unitNos = [];
      imageSrc = ''
    }
    return {
      formData: formData,
      rules: {
        name: [
          {required: true, message: '请输入活动名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择内容类型', trigger: 'change'},
        ],
        content: [
          {required: true, message: '请输入文本内容', trigger: 'blur'},
        ],
        imageSrc: [
          {required: true, message: '请选择图片', trigger: 'blur'},
        ],
        unitNo: [
          {required: true, message: '请选择所属组织', trigger: 'change'},
        ],
        enableStatus: [
          {required: true, message: '请选择启用情况', trigger: 'change'},
        ],
      },
      unitNos: unitNos,
      imageSrc: imageSrc
    }
  },


  watch: {
    unitNos: function (unitNos) {
      let formData = {...this.formData};
      formData.unitNo = unitNos[unitNos.length - 1] || ''
      this.formData = formData;
    },

    imageSrc: function (imageSrc) {
      let formData = {...this.formData};
      formData.imageSrc = imageSrc;
      this.formData = formData;
    }
  },

  computed: {
    subtitle() {
      return this.type === 1 ? '新增' : '编辑'
    }
  },

  mounted() {

  },

  methods: {
    back() {
      this.$emit('back')
    },
    handleUpload(file) {
      let fileReader = new FileReader();
      fileReader.onloadend = e => {
        this.imageSrc = e.target.result;
      }
      fileReader.readAsDataURL(file.raw);
    },

    onSubmit() {
      const form = this.$refs.form;
      form.validate((valid) => {
        if (valid) {
          this.createOrUpdate({...this.formData})
        } else {
          return false;
        }
      });
    },

    createOrUpdate(params) {
      this.$http.post('/managementPlatform/admin/createOrUpdateMarketingActivity', this.$qs.stringify(params)
      ).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          return this.$message.error(res.message)
        }
        this.$message.success("操作成功")
        this.$emit('back', true)
      }).catch(function (response) {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.marketing-activity-form {
  .filter-bar {
    display: flex;
    align-items: center;

    .item {
      margin-right: 10px;
      min-width: 260px;

      .el-input {
        width: 160px;
      }

      .el-cascader,
      .el-select,
      .el-date-editor {
        width: 200px;
      }
    }
  }

  .main-body {
    .form-container {
      width: 400px;

      .el-cascader,
      .el-select {
        width: 300px;
      }

      .buttons {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding: 20px 0;

        .el-button {
          min-width: 100px;
        }
      }
    }
  }

  .table-custom {
    th, td {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/marketingActivityForm.vue